import { createFileRoute } from '@tanstack/react-router';

import {
  customersReportQueryOptions,
  CustomersReportPage,
  resolveRange,
  todayIn,
} from '@/features/reports';

export const Route = createFileRoute('/_authed/_active/s/$storeId/reports/customers')({
  staticData: { crumb: 'reports:tabs.customers', tours: ['reports.customers'] },
  loaderDeps: ({ search }) => ({ range: search.range, from: search.from, to: search.to }),
  loader: ({ context, params, deps }) =>
    context.queryClient
      .query({
        ...customersReportQueryOptions(
          params.storeId,
          resolveRange(deps, todayIn(context.store.timezone)),
        ),
        staleTime: 'static',
      })
      .catch(() => undefined),
  component: CustomersReportPage,
});
